import { store } from "@redux"
import { io } from "socket.io-client"

const API_MAIN_URL =
  process.env.REACT_APP_API_MAIN_URL

const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL ||
  API_MAIN_URL.replace(/\/(main|auth|analytic|storage|subscribe)\/?$/, "")

const createSocketConnectionToServer = () => (
  new Promise((resolve, reject) => {
    const accessToken =
      localStorage.getItem("at")

    const path =
      process.env.NODE_ENV === "production"
        ? "/socket/s/"
        : "/s/"

    const socket =
      io(
        SOCKET_URL,
        {
          withCredentials: true,
          path,
          transports: ["websocket"],
          auth: {
            token: `Bearer ${accessToken}`,
            clientName:
              store.getState().systemSettings.clientName
          }
        }
      )

    socket.once("connect", () => {
      resolve(socket)
    })

    socket.once("connect_error", () => {
      reject()
    })
  })
)


export default createSocketConnectionToServer
